import { render, staticRenderFns } from "./Netdata.vue?vue&type=template&id=131cb258&scoped=true&"
import script from "./Netdata.vue?vue&type=script&lang=js&"
export * from "./Netdata.vue?vue&type=script&lang=js&"
import style0 from "./Netdata.vue?vue&type=style&index=0&id=131cb258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131cb258",
  null
  
)

export default component.exports